import { createGlobalStyle } from 'styled-components';

export const GlobalScrollbarStyles = createGlobalStyle`
  /* Webkit browsers (Chrome, Safari, Edge) */
  *::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  *::-webkit-scrollbar-corner {
    background: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.themeColors.border.strong};
    border-radius: 16px;
  }
`;
